import { isPwa } from '../../utils/pwaUtils';

export function isIosDevice(userAgent: string) {
  return /iphone|ipad|ipod/i.test(userAgent);
}

/**
 * Running as the installed app: Chrome's `display-mode`, or the flag iOS sets
 * in a web app opened from the Home Screen.
 */
export function isInstalledApp() {
  return (
    isPwa() ||
    Boolean((navigator as Navigator & { standalone?: boolean }).standalone)
  );
}

/**
 * An app's own browser (Instagram, Facebook, the Google app) has no "Add to
 * Home Screen" and never sends Chrome's install offer.
 */
export function isInAppBrowser(userAgent: string) {
  return /\b(FBAN|FBAV|FBIOS|Instagram|GSA)\b/i.test(userAgent);
}

/**
 * Whether Share sits behind Safari's "•••" button beside the address bar, as
 * in iOS 26's compact layout. Read from `Version/`, Safari's own version: from
 * 26 on, Safari freezes the OS in its user agent (`OS 18_6`, `18_7`). A
 * browser of its own on iOS (Chrome, Firefox, Edge, Opera) keeps its own
 * Share button and is left out.
 */
export function hidesShareBehindMore(userAgent: string) {
  if (!isIosDevice(userAgent) || /crios|fxios|edgios|opios/i.test(userAgent)) {
    return false;
  }
  const safariVersion = /version\/(\d+)/i.exec(userAgent)?.[1];
  return Number(safariVersion) >= 26;
}
